import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'src/app/services/shared/toaster/toaster.service';
import { UtilityService } from "src/app/services/shared/utility/utility.service";
import { BotRegistrationService } from "src/app/services/core/bot-registration/bot-registration.service";
import { ActivatedRoute } from "@angular/router";
import { IBroadcastBotInfo } from "src/app/models/broadcast";
import { Subscription } from "rxjs";
import { AgentHistoryService } from 'src/app/services/core/agent-history/agent-history.service';
import { IActiveAgentDetails, IAgentChatInfo, IAgentHistoryDetails, IAgentInformation } from 'src/app/models/agenthistory';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/core/user/user.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ExportService } from '../../../services/shared/export/export.service';
import { IAgentChatHistoryInfo } from 'src/app/models/chat-history';


@Component({
  selector: 'app-agentsinfo',
  templateUrl: './agentsinfo.component.html',
  styleUrls: ['./agentsinfo.component.scss']
})
export class AgentsinfoComponent implements OnInit {
  private _subscriptions = new Subscription();
  constructor(private botRegistrationService: BotRegistrationService,    
    private toasterService: ToasterService,
    private utilityService: UtilityService,
    private agentHistoryService :AgentHistoryService,
    private datePipe: DatePipe, private dialogWarning: MatDialog, private userService: UserService,
    private exportService: ExportService) { }
    superAdmin: boolean;    
    botConfigId: number;
    private userRoles: string[] = [];
    columnDefs: any[] = [];
    columnDefs_history: any[] = [];
    private route: ActivatedRoute;
    broadcastBotInfo: IBroadcastBotInfo;
    selectedBot = "";
    selectedOption: Number;
    rowDataActiveAgent = [];
    rowDataHistoryAgent = [];
    activeAgentList: IActiveAgentDetails[] = [];
    historyAgentList: IAgentHistoryDetails[] = [];
    private gridApi;
    private gridColumnApi;
    selectedDate: string;
    domLayout:string;
    paginationPageSize = 100;
    agentData;
    displayStyle = "none";
    agents = [];
    agentList = [];
    agentInformation: IAgentInformation[] = [];    
    myGroup = new FormGroup({
      Agent: new FormControl(),
      selectedEndDate: new FormControl(),
      selectedStartDate: new FormControl()
      // Make sure this control is defined
    });
  agentControl = new FormControl();
  selectedAgents: string[];
  selectedStartDate: string;
  selectedEndDate: string;
  agentChatInfoJson: IAgentChatInfo[] = [];
  showExportButton: boolean;
  previousSelectedAgents: string[] = [];

 

  onBotChange(event) {
    if (event.target.value != -1) {
      this.botConfigId = event.target.value;
      this.selectedBot = event.target.options[event.target.options.selectedIndex].text;
      this.createRowData();
      this.setBotInfoSession();
      this.getAllUsers(this.botConfigId);
      this.selectedStartDate = "";
      this.selectedEndDate = "";

    }
  }
      
  ShowAgentHistory() {
    if (this.selectedOption != -1) {
      this.selectedStartDate = this.datePipe.transform(this.selectedStartDate, 'yyyy-MM-dd');
      this.selectedEndDate = this.datePipe.transform(this.selectedEndDate, 'yyyy-MM-dd');
      if (this.selectedStartDate > this.selectedEndDate) {
        this.toasterService.error('Start date must be before end date.');
        return false;
      }
      if (this.selectedAgents === undefined && this.selectedStartDate == null || this.selectedEndDate == null) {
        this.toasterService.error("Please Select all Mandatory Dates and Agents");
      }
      else if (this.selectedStartDate == null || this.selectedEndDate == null && this.selectedAgents.length < 0) {
        this.toasterService.error("Please Select all Mandatory Dates and Agents");
      }
      else if (this.selectedAgents === undefined || this.selectedAgents.length === 0) {
        this.toasterService.error("Please Select  Agent");
      }
      else if (this.selectedStartDate && this.selectedEndDate && this.selectedAgents.length > 0 ) {
        this.getDataForAgentHistory(this.selectedOption, this.selectedStartDate, this.selectedEndDate, this.selectedAgents);
      }
      
    }
    else {
      this.toasterService.error(
        "Please choose Bot"
      );
    }  
  }
    
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      this.gridColumnApi = params.columnApi;
      this.gridApi.setDomLayout("autoHeight");
      this.gridApi.paginationSetPageSize(15);
    }
    setBotInfoSession() {
      let botInfo = {
        botConfigId: this.botConfigId,
        displayName: this.selectedBot,
      };
      let botData = JSON.stringify(botInfo);
      sessionStorage.removeItem("AgentHistory");
      sessionStorage.setItem("AgentHistory", botData);
    }

    setBotList(botlistResult) {
      let listOfBots = [];
      listOfBots.push({ botConfigId: -1, displayName: "-Select Bot-" });
      if (this.superAdmin) {        
        botlistResult.forEach((item) => {
          listOfBots.push({
            botConfigId: item.botConfigId,
            displayName: item.displayName,
          });
        });
      } else {
        let botIds = this.utilityService.GetFeaturewiseBotList(sessionStorage.getItem('userBotRoles'),"AgentHistory");
          botlistResult.forEach((item) => {
          botIds.forEach((botConfigId) => {
            if (botConfigId == item.botConfigId) {
              listOfBots.push({
                botConfigId: item.botConfigId,
                displayName: item.displayName
              });
            }
          });
        });
      }
      return listOfBots;
  }
  setAgentList(agentlistResult) {
    let listOfAgents = [];
      const seenUserIds = new Set();
      agentlistResult.forEach((item) => {
        if (!seenUserIds.has(item.userId)) {
          listOfAgents.push({
            emailID: item.username,
            firstName: item.firstname,
            lastName: item.lastname,
            UserId: item.userId
          });
          seenUserIds.add(item.userId);
        }
      });
    return listOfAgents;
  }
  onAgentSelectionChange() {
    const allValue = 'all';
    let currentSelectedAgents = this.myGroup.get('Agent').value as string[];
    let clickedOption;

    if (currentSelectedAgents.length > this.previousSelectedAgents.length) {
      // If the current selection has more items, find the added item
      clickedOption = currentSelectedAgents.find(agent => !this.previousSelectedAgents.includes(agent));
    } else if (currentSelectedAgents.length < this.previousSelectedAgents.length) {
      // If the current selection has fewer items, find the removed item
      clickedOption = this.previousSelectedAgents.find(agent => !currentSelectedAgents.includes(agent));
    }

    if (clickedOption === allValue) {
      // If "ALL" was clicked
      if (currentSelectedAgents.includes(allValue)) {
        // If "ALL" is now selected, select all agents
        this.selectedAgents = this.agents.map(agent => agent.UserId).concat(allValue);
      } else {
        // If "ALL" is now deselected, deselect all agents
        this.selectedAgents = [];
      }
    } else {
      // If an individual agent was clicked
      if (currentSelectedAgents.includes(allValue)) {
        // If "ALL" is still selected, remove it since an individual agent was clicked
        this.selectedAgents = currentSelectedAgents.filter(agent => agent !== allValue);
      } else {
        // If "ALL" is not selected, use the current selection
        this.selectedAgents = currentSelectedAgents;
      }
    }

    // Update the form control to reflect the current state, without emitting the change event
    this.myGroup.get('Agent').setValue(this.selectedAgents, { emitEvent: false });

    // Update the previous selection state
    this.previousSelectedAgents = [...this.selectedAgents];

  }
  getAllUsers(botConfigId: number) {
    this._subscriptions.add(
      this.userService.getAllUserRoles(botConfigId)
        .subscribe(
          res => {
            sessionStorage.setItem("lastActiveTab", "AgentChatInformation");

            this.agents = this.setAgentList(res);
            if (this.agents.length > 0) {
              this.agentInformation = this.agents[0];
            }
          },
          (error) => {
            this.toasterService.error("Unable to retrieve User-Roles");
          }
        )
    )
  }


  ngOnInit() {
    this.selectedOption = -1;
        //Taking accessed bot list
        this.botRegistrationService.getRegisteredBots().subscribe(
          (res) => {
            sessionStorage.setItem("lastActiveTab", "AgentHistory");
            this.botList = this.setBotList(res);
            if (this.botList.length > 0) {
              this.botConfigId = this.botList[0].botConfigId;            
            }
          },
          (error) => {
            this.toasterService.error(
              "Unable to fetch BOT(s) details at the moment"
            );
          }
        );

        this.userRoles = sessionStorage.getItem("userRoles")
      ? sessionStorage.getItem("userRoles").split(",")
      : [];
    let superAdminUser = this.userRoles.find(
      (ob) =>
        ob.toLowerCase() === "superadmin" || ob.toLowerCase() === "super admin"
    );
    if (superAdminUser) {
      this.superAdmin = true;
    }
  }
  botList: any;
  createColumnDefs() {
    const customComparator = (valueA, valueB) => {
      valueA = valueA ? valueA : "";
      valueB = valueB ? valueB : "";
      return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    };
    const columnDefs = [
      {
        headerName: "Agent Name",
        field: "agentName",
        width: 180,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Agent Type",
        field: "agentType",
        width: 140,
        comparator: customComparator,
        filter: false,
        sortable: false,
      },
      {
        headerName: "Email ID",
        field: "emailId",
        width: 250,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Login Time (UTC)",
        field: "agentStartTime",
        width: 180,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Active",
        field: "activeChats",
        width: 75,
        comparator: customComparator,
        filter: false,
        sortable: false,
      },
      {
        headerName: "Attended",
        field: "chatsAttended",
        width: 95,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "In Queue",
        field: "chatsInQueue",
        width: 90,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Closed",
        field: "chatsClosed",
        width: 80,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      }    
    ];
    this.columnDefs = columnDefs;
  }
  onSubmit() {  
    if(this.selectedOption != -1){
      this.selectedDate=this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    if(this.selectedDate !=null){
      this.createRowDataForAgentHistory();
    }
    else{
      this.toasterService.error(
        "Please select particular date"
      );
    }     
    }
    else{
      this.toasterService.error(
        "Please choose Bot"
      );
    }
   
  } 

  createRowData() {
    this.rowDataActiveAgent = [];
    this._subscriptions.add(
      this.agentHistoryService.GetAllActiveAgents(this.botConfigId).subscribe(
        (res) => {
          this.activeAgentList = res;
          this.rowDataActiveAgent = this.activeAgentList;
          this.createColumnDefs();
        },
        (error) => {
          this.toasterService.warn("No active agents found");
        }
      )
    );
  }
  //Agent History
  createHistoryColumnDefs() {
    const customComparator = (valueA, valueB) => {
      valueA = valueA ? valueA : "";
      valueB = valueB ? valueB : "";
      return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    };
    const columnDefs_history = [
      {
        headerName: "Agent Name",
        field: "agentName",
        width: 150,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Agent Type",
        field: "agenttype",
        width: 150,
        comparator: customComparator,
        filter: false,
        sortable: false,
      },
      {
        headerName: "Email ID",
        field: "emailId",
        width: 200,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Session Start Time(UTC)",
        field: "startTime",
        width: 180,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Session End Time(UTC)",
        field: "endTime",
        width: 180,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Status",
        field: "sessionStatus",
        width: 80,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Spend Time(hh:mm:ss)",
        field: "spendTime",
        width: 167.5,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      }
    ];
    this.columnDefs_history = columnDefs_history;
  }
  createRowDataForAgentHistory() {
    this._subscriptions.add(
      this.agentHistoryService.GetHistoryAgents(this.botConfigId,this.selectedDate).subscribe(
        (res) => {
          this.historyAgentList = res;
          this.rowDataHistoryAgent = this.historyAgentList;
          this.createHistoryColumnDefs();
        },
        (error) => {
          this.toasterService.warn("No agent history found");
        }
      )
    );
  }
  getDataForAgentHistory(botConfigId, selectedStartDate, selectedEndDate, selectedAgents) {
    this._subscriptions.add(
      this.agentHistoryService.GetAgentChatHistoryDetails(botConfigId, selectedAgents, selectedStartDate, selectedEndDate).subscribe(
        (res) => {
          if (res.length == 0) {
            this.toasterService.warn("No agent chat history found");
          }
          this.agentChatInfoJson = res;  // Fetching data for CSV export method.
          this.showExportButton = this.agentChatInfoJson.some(agentChatInfo => agentChatInfo.ChatAgentHistoryData.length > 0); // Enable/Disable the export button if data is available.
        },
        (error) => {
          this.agentChatInfoJson = null;
          this.toasterService.warn("No agent chat history found");
        }
      )
    );
  } 

  exportCSV(): void {

    const exportData = [];
    this.agentChatInfoJson.forEach(agent => {
      const { AgentEmail, AgentName } = agent;  // Extract the agent's email and name

      const agentChatInfo = agent.ChatAgentHistoryData.map(chat => ({  
        AgentName,
        AgentEmail,
        UserName: chat.BotUserName,
        ChatReceivedTime: chat.ChatReceivedTime,
        ChatAttentedTime: chat.ChatAttentedTime,
        ChatResponseTime: chat.ChatResponseTime,
        ChatClosedTime: chat.ChatClosedTime,
        ChatResolutionTime: chat.ChatResolutionTime,
        ChatClosed: chat.ChatClosed,
        ChatStatus: chat.ChatStatus
      }));  // Extracting the Agent Name and Agent Email from external list to ChatAgentHistoryData list to combine as a single list. Also Sorting the data according to Column Header
       
      exportData.push({
        ChatAgentHistoryData: agentChatInfo // Pushing the Agent Name and Agent Email from external list to ChatAgentHistoryData list 
      });
    });

    const flattenedData: IAgentChatHistoryInfo[] = [].concat(...exportData.map(agent => agent.ChatAgentHistoryData)); // Converting the multiple listed array into single array list

    const columnsToInclude = [
      'AgentEmail',
      'AgentName',
      'UserName',
      'ChatReceivedTime',
      'ChatAttentedTime',
      'ChatResponseTime',
      'ChatClosedTime',
      'ChatResolutionTime',
      'ChatClosed',
      'ChatStatus'
    ]; // Add the columns Header to be added in CSV in sorted order

    this.exportService.exportToCsv(flattenedData, 'Agent_Chat_History_Info', columnsToInclude);
  }
}

